import { PageContent, PageHeader } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { useTranslation } from 'react-i18next';
import { Route, Routes, useLocation } from 'react-router';
import { ProjectsPageDynamicLink } from '../_components/ProjectsPageDynamicLink';
import { SplitProjectPage } from '../forms/_pages/SplitProjectPage';
import { UpdateProjectPage } from '../forms/_pages/UpdateProjectPage';
import { ProjectDetailsPageHeader } from './_components/ProjectDetailsPageHeader';
import { ProjectDrawerStateProvider } from './_components/ProjectDrawerStateProvider';
import { ProjectDetailsPage } from './_pages/ProjectDetailsPage';
import { ProjectDiffPage } from './diff/_pages/ProjectDiffPage';
import { ProjectFundOwnerForLocalGovernmentElement } from './fund/_components/ProjectFundOwnerForLocalGovernmentElement';
import { ProjectLedgerPage } from './ledger/_pages/ProjectLedgerPage';

export const ProjectDetailRoutes = () => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <ProjectDrawerStateProvider>
      <Routes>
        <Route
          index
          element={
            <>
              <ProjectDetailsPageHeader />
              <PageContent>
                <ProjectDetailsPage />
              </PageContent>
            </>
          }
        />
        <Route path="/report" element={<ProjectLedgerPage />} />
        <Route
          path="/fund-owner-for-local-government-report"
          element={<ProjectFundOwnerForLocalGovernmentElement />}
        />
        <Route
          path="/edit"
          element={
            <ProjectResourceGuard onlyEdit>
              <PageHeader
                title={t('update-project-page')}
                breadcrumbs={[
                  { title: <ProjectsPageDynamicLink /> },
                  {
                    title: t('project-details-page'),
                    href: `${location.pathname
                      .split('/')
                      .slice(0, -1)
                      .join('/')}`,
                  },
                  {
                    title: t('update-project-page'),
                  },
                ]}
              />
              <PageContent>
                <UpdateProjectPage />
              </PageContent>
            </ProjectResourceGuard>
          }
        />
        <Route path="/diff" element={<ProjectDiffPage />} />
        <Route
          path="/split"
          element={
            <ProjectResourceGuard onlyEdit>
              <PageHeader
                title={t('split-project-page')}
                breadcrumbs={[
                  { title: <ProjectsPageDynamicLink /> },
                  {
                    title: t('project-details-page'),
                    href: `${location.pathname
                      .split('/')
                      .slice(0, -1)
                      .join('/')}`,
                  },
                  {
                    title: t('split-project-page'),
                  },
                ]}
              />
              <PageContent>
                <SplitProjectPage />
              </PageContent>
            </ProjectResourceGuard>
          }
        />
      </Routes>
    </ProjectDrawerStateProvider>
  );
};
